import React, { useEffect, useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";

import AddSpecial1 from "./addSpecial1";
import AddSpecial2 from "./addSpecial2";
import EditSpecial1 from "./editSpecial1";
import EditSpecial2 from "./editSpecial2";
const { width, height } = Dimensions.get("window");
import { Modal } from "react-native-web";
import { useRecoilValue } from "recoil";
import { univer, userState } from "../reducer";
import { apiservice } from "../service/api";
import { useIsFocused } from "@react-navigation/native";
import { deleteFlag } from "../action/utlis";
import moment from "moment";
const manageSpecial = () => {
  const [data1, setdata1] = useState([]);
  const [data2, setdata2] = useState([]);
  const [page, setpage] = useState(0);
  const [page1, setpage1] = useState(1);
  const [modal, setmodal] = useState(false);
  const [state, setstate] = useState({});
  const [state1, setstate1] = useState({});
  const user = useRecoilValue(userState);
  const university = useRecoilValue(univer);
  const [fill, setFill] = useState("");
  const isFocus = useIsFocused();

  async function getallUniversity() {
    const res = await apiservice({
      path: "/adv/getalladvuser?university_id=" + user.university_id,
      method: "get",
    });
    if (res.status == 200) {
      setdata1(res.data.filter((item) => item.Type == "SPECIAL"));
      setdata2(res.data.filter((item) => item.Type == "SPECIALWORK"));
    }
  }

  useEffect(() => {
    getallUniversity();
  }, [isFocus, page]);

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบข้อมูลนี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.25,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  const del = await deleteFlag(state.id);
                  if (del) {
                    setmodal(false);
                    getallUniversity();
                  }
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={{ width: width * 0.591, flexDirection: "row" }}>
            <TouchableOpacity
              onPress={() => setpage1(1)}
              style={{
                borderBottomWidth: 1,
                borderColor: page1 == 1 ? "#002377" : "#ffff",
                marginRight: 20,
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: "Prompt-Bold",
                  color: "#202020",
                }}
              >
                สิทธิประโยชน์
              </Text>
            </TouchableOpacity>

            {/* <TouchableOpacity
              onPress={() => setpage1(2)}
              style={{
                borderBottomWidth: 1,
                borderColor: page1 == 2 ? "#002377" : "#ffff",
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: "Prompt-Bold",
                  color: "#202020",
                }}
              >
                สิทธิพิเศษ
              </Text>
            </TouchableOpacity> */}
          </View>

          {page1 == 1 && (
            <View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.06,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    width: width * 0.235,
                    height: height * 0.037,
                    flexDirection: "row",
                  }}
                >
                  <TextInput
                    defaultValue={fill}
                    onChangeText={setFill}
                    style={{
                      width: width * 0.8,
                      height: height * 0.037,
                      borderWidth: 1,
                      overflow: "hidden",
                      borderColor: "#00237740",
                      paddingLeft: 5,
                      fontFamily: "Prompt-Regular",
                      fontSize: 12,
                    }}
                  />
                  <TouchableOpacity
                    style={{
                      width: width * 0.022,
                      height: height * 0.037,
                      backgroundColor: "#002377",
                    }}
                  >
                    <AntDesign
                      name="search1"
                      style={{ margin: "auto" }}
                      size={15}
                      color="#ffff"
                    />
                  </TouchableOpacity>
                </View>
                <TouchableOpacity
                  onPress={() => setpage(1)}
                  style={{
                    width: width * 0.045,
                    height: height * 0.037,
                    backgroundColor: "#43A2D4",
                    borderRadius: 5,
                  }}
                >
                  <Text style={styles.TextButton}>+ เพิ่ม</Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.546,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#C2C2C2",
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                }}
              >
                <View
                  style={{
                    width: width * 0.591,
                    height: height * 0.054,
                    backgroundColor: "#002377",
                    flexDirection: "row",
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                  }}
                >
                  <View
                    style={{ width: width * 0.123, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      ชื่อ
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.123, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      เวลาเริ่มต้น
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.095, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      เวลาสิ้นสุด
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.125, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      สถานะ
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.125, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: '#FFF' },
                      ]}
                    >
                      จัดการ
                    </Text>
                  </View>
                </View>

                <FlatList
                  data={data1.filter(
                    (items) =>
                      items.title.includes(fill) || items.post_by.includes(fill)
                  )}
                  renderItem={({ item, index }) => {
                    return (
                      <View
                        style={{
                          width: width * 0.591,
                          height: height * 0.06,
                          flexDirection: "row",
                          backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                        }}
                      >
                        <View
                          style={{
                            width: width * 0.123,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata} numberOfLines={1}>{item.title}</Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.123,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata}>
                            {moment(item.startdate)
                              .add(543, "years")
                              .format("DD/MM/YYYY")}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.095,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata}>
                            {moment(item.date)
                              .add(543, "years")
                              .format("DD/MM/YYYY")}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.125,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata}>
                            {moment().isBetween(moment(item.startdate), moment(item.date)) ? "ใช้งาน" : "ไม่ใช้งาน"}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.125,
                            height: height * 0.06,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <TouchableOpacity
                            onPress={() => {
                              setstate(item);
                              setpage(4);
                            }}
                            style={{
                              width: 70,
                              height: 30,
                              borderRadius: 5,
                              backgroundColor: "#69D443",
                            }}
                          >
                            <Text style={styles.TextButton}>แก้ไข</Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setstate(item);

                              setmodal(true);
                            }}
                            style={{
                              width: 70,
                              height: 30,
                              borderRadius: 5,
                              backgroundColor: "#D44343",
                            }}
                          >
                            <Text style={styles.TextButton}>ลบ</Text>
                          </TouchableOpacity>
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </View>
          )}
          {page1 == 2 && (
            <View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.06,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    width: width * 0.235,
                    height: height * 0.037,
                    flexDirection: "row",
                  }}
                >
                  <TextInput
                    defaultValue={fill}
                    onChangeText={setFill}
                    style={{
                      width: width * 0.8,
                      height: height * 0.037,
                      borderWidth: 1,
                      overflow: "hidden",
                      borderColor: "#00237740",
                      paddingLeft: 5,
                      fontFamily: "Prompt-Regular",
                      fontSize: 12,
                    }}
                  />
                  <TouchableOpacity
                    style={{
                      width: width * 0.022,
                      height: height * 0.037,
                      backgroundColor: "#002377",
                    }}
                  >
                    <AntDesign
                      name="search1"
                      style={{ margin: "auto" }}
                      size={15}
                      color="#ffff"
                    />
                  </TouchableOpacity>
                </View>
                <TouchableOpacity
                  onPress={() => setpage(2)}
                  style={{
                    width: width * 0.045,
                    height: height * 0.037,
                    backgroundColor: "#43A2D4",
                    borderRadius: 5,
                  }}
                >
                  <Text style={styles.TextButton}>+ เพิ่ม</Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.546,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#C2C2C2",
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                }}
              >
                <View
                  style={{
                    width: width * 0.591,
                    height: height * 0.054,
                    backgroundColor: "#002377",
                    flexDirection: "row",
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                  }}
                >
                  <View
                    style={{ width: width * 0.123, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      ชื่อ
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.123, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      เวลาเริ่มต้น
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.095, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      เวลาสิ้นสุด
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.125, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      สถานะ
                    </Text>
                  </View>
                  <View
                    style={{ width: width * 0.125, height: height * 0.054 }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { color: "#FFF" },
                      ]}
                    >
                      จัดการ
                    </Text>
                  </View>
                </View>

                <FlatList
                  data={data2.filter(
                    (items) =>
                      items.title.includes(fill) || items.post_by.includes(fill)
                  )}
                  renderItem={({ item, index }) => {
                    return (
                      <View
                        style={{
                          width: width * 0.591,
                          height: height * 0.06,
                          flexDirection: "row",
                          backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                        }}
                      >
                        <View
                          style={{
                            width: width * 0.123,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata} numberOfLines={1} >{item.title}</Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.123,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata}>
                            {moment(item.startdate)
                              .add(543, "years")
                              .format("DD/MM/YYYY")}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.095,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata}>
                            {moment(item.date)
                              .add(543, "years")
                              .format("DD/MM/YYYY")}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.125,
                            height: height * 0.06,
                          }}
                        >
                          <Text style={styles.Textdata}>
                            {moment().isBetween(moment(item.startdate), moment(item.date)) ? "ใช้งาน" : "ไม่ใช้งาน"}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.125,
                            height: height * 0.06,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <TouchableOpacity
                            onPress={() => {
                              setstate(item);
                              setpage(4);
                            }}
                            style={{
                              width: 70,
                              height: 30,
                              borderRadius: 5,
                              backgroundColor: "#69D443",
                            }}
                          >
                            <Text style={styles.TextButton}>แก้ไข</Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setstate(item);
                              setmodal(true);
                            }}
                            style={{
                              width: 70,
                              height: 30,
                              borderRadius: 5,
                              backgroundColor: "#D44343",
                            }}
                          >
                            <Text style={styles.TextButton}>ลบ</Text>
                          </TouchableOpacity>
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </View>
          )}
        </View>
      )}

      {page == 1 && <AddSpecial1 setpages={setpage} />}
      {page == 2 && <AddSpecial2 setpages={setpage} />}
      {page == 3 && <View />}
      {page == 4 && <EditSpecial1 state={state} setpages={setpage} />}
      {page == 5 && <EditSpecial2 state1={state1} setpages={setpage} />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: {
    fontSize: 20,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  Textdata: { fontSize: 16, margin: "auto", fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});
export default manageSpecial;
